module.exports = __webpack_public_path__ + "static/media/farm_pharm_8.254e2bc1.jpg";